const FiltersSection = ({
  darkMode,
  academicYear,
  setAcademicYear,
  academicYears,
  semesterType,
  setSemesterType,
  isLoading,
  fetchCourses,
  defaultAcademicYear,
}) => (
  <div
    className="rounded-lg p-5 mb-4 border"
    style={{
      backgroundColor: darkMode ? "#0D1117" : "#F8FAFC",
      borderColor: darkMode ? "#22232B" : "#D1D5DB",
      boxShadow: darkMode ? "none" : "0 1px 3px rgba(0, 0, 0, 0.05)",
    }}
  >
    {/* Enhanced Header */}
    <div className="flex items-center mb-4">
      <div
        className="w-1 h-6 rounded-full mr-3"
        style={{ backgroundColor: darkMode ? "#3B82F6" : "#2563EB" }}
      ></div>
      <h3
        className="text-lg font-semibold"
        style={{ color: darkMode ? "#FFFFFF" : "#111827" }}
      >
        Filter Courses
      </h3>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {/* Academic Year Dropdown */}
      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: darkMode ? "#C9CCD1" : "#374151" }}
        >
          Academic Year
        </label>
        <select
          value={academicYear}
          onChange={(e) => setAcademicYear(e.target.value)}
          className="w-full p-2.5 rounded-lg border transition-all duration-300 cursor-pointer"
          style={{
            backgroundColor: darkMode ? "#161B22" : "#FFFFFF",
            borderColor: darkMode ? "#22232B" : "#D1D5DB",
            color: darkMode ? "#EAEAEA" : "#111827",
          }}
          onMouseEnter={(e) => {
            e.target.style.borderColor = darkMode ? "#3B82F6" : "#2563EB";
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = darkMode ? "#22232B" : "#D1D5DB";
          }}
        >
          {academicYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      {/* Semester Type Dropdown */}
      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: darkMode ? "#C9CCD1" : "#374151" }}
        >
          Semester Type
        </label>
        <select
          value={semesterType}
          onChange={(e) => setSemesterType(e.target.value)}
          className="w-full p-2.5 rounded-lg border transition-all duration-300 cursor-pointer"
          style={{
            backgroundColor: darkMode ? "#161B22" : "#FFFFFF",
            borderColor: darkMode ? "#22232B" : "#D1D5DB",
            color: darkMode ? "#EAEAEA" : "#111827",
          }}
          onMouseEnter={(e) => {
            e.target.style.borderColor = darkMode ? "#3B82F6" : "#2563EB";
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = darkMode ? "#22232B" : "#D1D5DB";
          }}
        >
          <option value="odd">Odd Semester</option>
          <option value="even">Even Semester</option>
        </select>
      </div>
      {/* Fetch Button */}
      <div className="flex items-end">
        <button
          onClick={fetchCourses}
          disabled={isLoading}
          className="w-full px-4 py-2.5 rounded-lg font-medium text-sm transition-all duration-300 flex items-center justify-center"
          style={{
            backgroundColor: darkMode
              ? isLoading
                ? "rgba(59, 130, 246, 0.5)"
                : "#3B82F6"
              : isLoading
                ? "rgba(37, 99, 235, 0.7)"
                : "#2563EB",
            color: "#FFFFFF",
            border: "none",
            boxShadow: darkMode
              ? "0 2px 4px rgba(0, 0, 0, 0.2)"
              : "0 2px 4px rgba(37, 99, 235, 0.2)",
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.target.style.backgroundColor = darkMode ? "#2563EB" : "#1D4ED8";
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = darkMode
                ? "0 4px 8px rgba(0, 0, 0, 0.3)"
                : "0 4px 8px rgba(37, 99, 235, 0.3)";
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading) {
              e.target.style.backgroundColor = darkMode ? "#3B82F6" : "#2563EB";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = darkMode
                ? "0 2px 4px rgba(0, 0, 0, 0.2)"
                : "0 2px 4px rgba(37, 99, 235, 0.2)";
            }
          }}
        >
          {isLoading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Loading...
            </>
          ) : (
            "Fetch Courses"
          )}
        </button>
      </div>
    </div>
  </div>
);

export default FiltersSection;
